/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { GridContext as n } from "../../GridClientWrapper.mjs";
import { cloneReactElement as r } from "../../utils/index.mjs";
const m = (t) => {
  const o = {
    style: { ...e.useContext(n).getCellPositionStyle(t.column) }
  };
  return r(t.children, {
    ...o
  });
};
export {
  m as GridFilterCellElementContainer
};
